<template>
        <v-layout pa-7>
            <v-flex class="align-center">
                <v-layout justify-space-between mb-3>
                    <v-flex shrink style="color: #FF5100;">
                        {{ $t('page.data-stat.industry') }}
                    </v-flex>
                    <v-flex shrink>
                        {{ $t('general.unit') }}: {{ unit }}
                    </v-flex>
                </v-layout>
                <canvas id="MeSeStatusCanvas"></canvas>
            </v-flex>
        </v-layout>
</template>

<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: ['chartdata', 'options', 'dataname','unit','displayLabels'],

        mounted() {

            Chart.defaults.global.legend.display = false;

            var MeSeContext = document.getElementById("MeSeStatusCanvas").getContext("2d");
            var MeSeData = {
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: '#FF5100',
                        data: this.options,
                        // Change options only for labels of THIS DATASET
                        datalabels: {
                            display: !!this.displayLabels,
                        },
                    }
                ]
            };

            new Chart(MeSeContext, {
                type: 'horizontalBar',
                data: MeSeData,
                options: {
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                return this.dataname + ": " + tooltipItem.xLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            }
                        }
                    }
                }
            });
        }
    }
</script>

<style scoped>

    .titleCard {
        background: #4F4F4F;
        color: #FFFFFF;
    }

</style>
